import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import { QueryClientProvider } from "@tanstack/react-query";
import appRouter from "./router/AppRouter.tsx";
import { RouterProvider } from "@tanstack/react-router";
import { PreferenceEffects } from "./components/PreferenceEffects";
import { ThemeProvider } from "./theme";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { initializeAnalytics } from "./analytics/posthog";
import { queryClient } from "./api/queryClient";

initializeAnalytics(appRouter);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ErrorBoundary>
      <ThemeProvider>
        <PreferenceEffects />
        <QueryClientProvider client={queryClient}>
          <RouterProvider router={appRouter}></RouterProvider>
        </QueryClientProvider>
      </ThemeProvider>
    </ErrorBoundary>
  </StrictMode>,
);
